import { createContext } from "react";
import React from "react";

export const UrlContext = createContext();

export const UrlProvider = ({ children }) => {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  let API_URL;
  let URI;

  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    API_URL = "https://test.expertpowerhouse.com/api/";
    URI = "https://consultant.expertpowerhouse.com/";
  } else if (process.env.REACT_APP_ENVIRONMENT === "production") {
    API_URL = "https://consultant.expertpowerhouse.com/api/";
    URI = "https://consultant.expertpowerhouse.com/";
  } else {
    API_URL = "https://consultant.expertpowerhouse.com/api/";
    URI = "http://localhost:3000/";
  }

  return (
    <UrlContext.Provider value={{ API_URL, URI }}>
      {children}
    </UrlContext.Provider>
  );
};
